import { useMutation } from "@tanstack/react-query";

import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import { postAndValidate } from "~/shared/services/api/fetch-client.ts";
import type { ApiResult } from "~/shared/types/api-types.ts";
import { getIsInternal } from "~/shared/utils/get-deployment-type.ts";

import type {
	BulkTenderRequest,
	BulkTenderResponse,
} from "../schemas/bulk-tender-schema.ts";
import {
	bulkTenderRequestSchema,
	bulkTenderResponseSchema,
} from "../schemas/bulk-tender-schema.ts";

const INVALID_REQUEST_MESSAGE =
	"Select at least one valid shipment before tendering.";

export const useBulkTender = () => {
	return useMutation<ApiResult<BulkTenderResponse>, Error, BulkTenderRequest>({
		mutationFn: async (request) => {
			const parsedRequest = bulkTenderRequestSchema.safeParse(request);
			if (!parsedRequest.success) {
				return {
					success: false,
					error: INVALID_REQUEST_MESSAGE,
					details: parsedRequest.error,
				} as const;
			}

			const route = getIsInternal()
				? apiRoutes.BULKTENDER
				: apiRoutes.BULKTENDERCUSTOMER;
			return await postAndValidate(
				route,
				parsedRequest.data,
				bulkTenderResponseSchema,
			);
		},
	});
};
